export default "__VITE_ASSET__Ba5D$lSZ__"